import { render, staticRenderFns } from "./RpRedirect.vue?vue&type=template&id=805ba59a&scoped=true&"
import script from "./RpRedirect.vue?vue&type=script&lang=ts&"
export * from "./RpRedirect.vue?vue&type=script&lang=ts&"
import style0 from "./RpRedirect.vue?vue&type=style&index=0&id=805ba59a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805ba59a",
  null
  
)

export default component.exports